
import EventDispatcher from '@/base/event/event-dispatcher';
import $ from 'jquery';
import tmpl from './tmpl/_zoom.art';
import './tmpl/zoom.scss';
import { getWH } from '@/components/player/media';

class Pager extends EventDispatcher {
    constructor(options, $parent) {
        super();
        this.percentage = 100
        this.screen = getWH(); // 获取展示区域宽高
        this.contentWidth = $('.content').width()
        this.$parent = $parent || $('body'); // 当前元素
        this.options = options || {};
        this.render();
        this.bindEvents();
        this.setPercent()

        if(this.screen.clientWidth < this.screen.standard) { // 小屏
            // 重定义zoom 样式
            this.reset()
        }
    }

    render() {
        this.$el = $(tmpl(this.options));
        this.$parent.append(this.$el);
        return this;
    }

    reset() {
        this.$el.addClass('dp-zoom-iphone')
    }

    setPercent(zoomType) {
        this.$el.find('.zoom-text').text(this.percentage + '%')
        if ((zoomType == 'zoomIn' && this.percentage >= 50) || (zoomType == 'zoomOut' && this.percentage <= 200)) {
            this.contentWidth = zoomType == 'zoomIn' ? this.contentWidth - 96 : this.contentWidth + 96
            $('.content').width(this.contentWidth).attr('style', `max-width: ${this.contentWidth}px; width: ${this.contentWidth}px;`)
        }
        return this;
    }

    bindEvents() {
        this.$el.on('click', '[data-action="zoomIn"]', evt => {
            this.$el.find('.icon-srt-plus').removeClass('zoom-plus-disable')
            if (this.percentage > 50) {
                this.percentage -= 10
                this.setPercent('zoomIn')
                if (this.percentage == 50) {
                    this.$el.find('.icon-srt-minus').addClass('zoom-minus-disable')
                }
            } else {
                this.$el.find('.icon-srt-minus').addClass('zoom-minus-disable')
            }
        });

        this.$el.on('click', '[data-action="zoomOut"]', evt => {
            this.$el.find('.icon-srt-minus').removeClass('zoom-minus-disable')
            if (this.percentage < 200) {
                this.percentage += 10
                this.setPercent('zoomOut')
                if (this.percentage == 200) {
                    this.$el.find('.icon-srt-plus').addClass('zoom-plus-disable')
                }
            } else {
                this.$el.find('.icon-srt-plus').addClass('zoom-plus-disable')
            }
        });
    }

    update(index, pageCount) {
        return this;
    }

    show() {
        this.$el.removeClass('hide').addClass('show');
        return this;
    }

    hide() {
        this.$el.removeClass('show').addClass('hide');
        return this;
    }
}

export default Pager;